import { render, staticRenderFns } from "./GuofuMap.vue?vue&type=template&id=60ea648b&scoped=true&"
import script from "./GuofuMap.vue?vue&type=script&lang=js&"
export * from "./GuofuMap.vue?vue&type=script&lang=js&"
import style0 from "./GuofuMap.vue?vue&type=style&index=0&id=60ea648b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ea648b",
  null
  
)

export default component.exports